// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var PromiseUtils$SmartcutsMacros = require("../../../bs-utils/src/PromiseUtils.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../../bs-utils/src/JsPromiseErrorUtils.bs.js");

function runPromiseWhileAlsoHandlingTabDraggingError(doPromise) {
  return PromiseUtils$SmartcutsMacros.untilNoMatchingJsPromiseError(undefined, doPromise, (function (error) {
                var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error);
                if (typeof jsExn === "number") {
                  return false;
                }
                if (jsExn.TAG !== /* JsExn */0) {
                  return false;
                }
                var match = jsExn._0.message;
                if (match === undefined) {
                  return false;
                }
                switch (match) {
                  case "Tabs cannot be edited right now (user may be dragging a tab)." :
                  case "Tabs cannot be queried right now (user may be dragging a tab)." :
                      return true;
                  default:
                    return false;
                }
              }), undefined);
}

exports.runPromiseWhileAlsoHandlingTabDraggingError = runPromiseWhileAlsoHandlingTabDraggingError;
/* PromiseUtils-SmartcutsMacros Not a pure module */
